<div class="camera-group" >
    <app-tree-play-back-item
       (eventChild)="parentSelected($event)"
       (eventIsClick)="getIsClick($event)"
       (eventSubChild)="getSubIdparent($event)"
       (camera)="getCameraLive($event)"
     *ngFor="let bunch of listBunch"  [bunch]="bunch" [term]="search"></app-tree-play-back-item>
 </div>